export default [
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
